import { Injectable } from '@angular/core';
import { interval, timer, Subscription } from 'rxjs';

export interface OtpResendCountdownHost {
  hideResendOTPButton: boolean;
  resendAvailable: boolean;
  otpSession10MinInterval: any;
  numbersubs: Subscription;
  isNumberSubSubscribed: boolean;
  disableOTPSendButton: boolean;
  secondsLeft: number;
  countDown: number;
}

export interface OtpSecLeftCountdownHost {
  disableOTPSendButton: boolean;
  numbersubs2: Subscription;
  isNumberSub2Subscribed: boolean;
  secondsLeft: number;
  secLeftResendAllowed: number;
}

@Injectable({ providedIn: 'root' })
export class OtpCountdownService {

  handleOtpSent(host: OtpResendCountdownHost) {
    host.hideResendOTPButton = false;
    host.resendAvailable = true;
    if (host.otpSession10MinInterval != undefined) {
      clearTimeout(host.otpSession10MinInterval);
    }
    if (host.isNumberSubSubscribed) {
      host.secondsLeft = 0;
      host.numbersubs.unsubscribe();
    }
    if (host.isNumberSubSubscribed) {
      host.numbersubs.unsubscribe();
    }

    host.disableOTPSendButton = true;
    host.numbersubs = this.startCountdown(
      host.countDown,
      (secondsLeft) => {
        host.isNumberSubSubscribed = true;
        host.secondsLeft = secondsLeft;
      },
      () => {
        host.isNumberSubSubscribed = false;
        host.disableOTPSendButton = false;
      }
    );
  }

  startSecLeftCountdown(host: OtpSecLeftCountdownHost) {
    host.disableOTPSendButton = true;
    host.numbersubs2 = this.startCountdown(
      host.secLeftResendAllowed,
      (secondsLeft) => {
        host.isNumberSub2Subscribed = true;
        host.secondsLeft = secondsLeft;
      },
      () => {
        host.isNumberSub2Subscribed = false;
        host.disableOTPSendButton = false;
      }
    );
  }

  startCountdown(totalSeconds: number, onTick: (secondsLeft: number) => void, onComplete: () => void): Subscription {
    const numbers = interval(1000);
    const subscription = numbers.subscribe(x => {
      const secondsLeft = totalSeconds - x;
      onTick(secondsLeft);
      if (secondsLeft == 0) {
        subscription.unsubscribe();
        onComplete();
      }
    });
    return subscription;
  }

  startCounter(initialValue: number, tickMs: number, onTick: (value: number) => void, onZero: () => void): Subscription {
    let counter = initialValue;
    const subscription = timer(0, tickMs).subscribe(() => {
      --counter;
      onTick(counter);
      if (counter === 0) {
        subscription.unsubscribe();
        onZero();
      }
    });
    return subscription;
  }
}
